import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, model } from '@angular/core';

import { DsButtonBase } from '@frontend/ui/shared';

export const DS_BUTTON_ICON_VARIANT_ARRAY = ['flat', 'filled', 'outline', 'flat-reduced'] as const;
export type DsButtonIconVariant = (typeof DS_BUTTON_ICON_VARIANT_ARRAY)[number];

export const DS_BUTTON_ICON_KIND_ARRAY = ['primary', 'secondary', 'tertiary', 'utility'] as const;
export type DsButtonIconKind = (typeof DS_BUTTON_ICON_KIND_ARRAY)[number];

export const DS_BUTTON_ICON_SIZES_ARRAY = ['small', 'medium', 'large'] as const;
export type DsButtonIconSizes = (typeof DS_BUTTON_ICON_SIZES_ARRAY)[number];

@Component({
    selector: 'button[ds-button-icon], a[ds-button-icon]',
    standalone: true,
    template: ` <span class="ds-icon-btn-icon">
        <ng-content />
    </span>`,
    styleUrl: './button-icon.component.scss',
    host: {
        'class': 'ds-button-icon',
        '[class]': 'hostClass()',
        '[class.ds-btn-icon-disabled]': 'disabled() ? true : null',
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsButtonIcon extends DsButtonBase {
    public readonly size = model<DsButtonIconSizes>('large');
    public readonly kind = model<DsButtonIconKind>('primary');
    public readonly variant = model<DsButtonIconVariant>('filled');

    protected readonly hostClass = computed(() => {
        const variantKindClass = `ds-btn-icon-${this.variant()}-${this.kind()}`;
        const sizeClass = this.variant() === 'flat-reduced' ? `ds-btn-icon-${this.size()}-reduced` : `ds-btn-icon-${this.size()}`;
        return `${variantKindClass} ${sizeClass}`;
    });
}
